module.exports = __webpack_public_path__ + "img/3.e5d77ec9.png";